export default __webpack_public_path__ + "static/media/photo-download.224231b8.svg";